<template>
  <div class="container">
    <titular />
    <div class="row mb-5">
      <div class="col">
        <form class="form-inline" @submit.prevent="listarFilas">
          <div class="btn-group btn-group-toggle mb-2 mr-sm-2" data-toggle="buttons">
            <label class="btn btn-secondary" :class="{ disabled: loading.filtrado, active: tipoRango == tipoRangos[0] }"><input type="radio" name="options" :value="tipoRangos[0]" v-model="tipoRango" /> Tot</label>
            <label class="btn btn-secondary" :class="{ disabled: loading.filtrado, active: tipoRango == tipoRangos[1] }" title="Últims 12 mesos" v-tooltip><input type="radio" name="options" :value="tipoRangos[1]" v-model="tipoRango" /> LTM</label>
            <label class="btn btn-secondary" :class="{ disabled: loading.filtrado, active: tipoRango == tipoRangos[2] }" title="Enguany" v-tooltip><input type="radio" name="options" :value="tipoRangos[2]" v-model="tipoRango" /> YTD</label>
          </div>
          <div class="input-group mb-2 mr-sm-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Inici</div>
            </div>
            <input type="date" class="form-control" v-model="rango_inicio" data-test-id="rango_inicio" :max="rango_fin" />
          </div>
          <div class="input-group mb-2 mr-sm-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Fi</div>
            </div>
            <input type="date" class="form-control" v-model="rango_fin" data-test-id="rango_fin" :min="rango_inicio" :max="rango_max" />
          </div>
          <div class="input-group mb-2 w-100">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-archive" title="Projecte" v-tooltip></i></div>
            </div>
            <select class="custom-select" v-model="proyecto_escogido" data-test-id="proyecto_escogido" required>
              <option value="" hidden>Projecte</option>
              <option v-for="(proyecto, index) in proyectos" :key="index" :value="proyecto.id">{{ proyecto.cliente }} → {{ proyecto.titol }}</option>
            </select>
          </div>
          <button ref="submit" type="submit" class="btn btn-primary mb-2 ml-auto" :disabled="loading.filtrado">
            <i-submit icono="fa-angles-right" :loading="loading.filtrado" />Filtrar
          </button>
          <button type="reset" class="btn btn-outline-secondary mb-2 ml-2" @click="reiniciarFilas"><i class="fas fa-backspace mr-1"></i>Reiniciar</button>
        </form>
      </div>
    </div>
    <template v-if="esFiltrado">
      <div class="row mb-5">
        <div class="col-12 col-sm-6">
          <div class="row mb-5">
            <div class="col text-center">
              <div class="px-5 px-sm-0">
                <estadistica-proyecto :prevision="prevision" />
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col">
              <div class="card bg-light">
                <div class="card-header">
                  Contacte del projecte
                </div>
                <ul v-if="contacto" class="list-group list-group-flush">
                  <li v-if="proyecto.contacte_nom" class="list-group-item"><i class="fa-solid fa-user-tie fa-fw" title="Nom" v-tooltip></i> <b>{{ proyecto.contacte_nom }}</b></li>
                  <li v-if="proyecto.contacte_carrec" class="list-group-item"><i class="fa-solid fa-briefcase fa-fw" title="Càrrec" v-tooltip></i> {{ proyecto.contacte_carrec }}</li>
                  <li v-if="proyecto.contacte_email" class="list-group-item"><i class="fa-solid fa-envelope fa-fw" title="E-mail" v-tooltip></i> <a v-if="comprobarEmailValido(proyecto.contacte_email)" :href="`mailto:${proyecto.contacte_email}`">{{ proyecto.contacte_email }}</a><span v-else>{{ proyecto.contacte_email }}</span></li>
                  <li v-if="proyecto.contacte_telefon" class="list-group-item"><i class="fa-solid fa-phone fa-fw" title="Telèfon" v-tooltip></i> <a v-if="comprobarTelefonoValido(proyecto.contacte_telefon)" :href="`tel:${proyecto.contacte_telefon}`">{{ proyecto.contacte_telefon }}</a><span v-else>{{ proyecto.contacte_telefon }}</span></li>
                </ul>
                <div v-else class="card-body">
                  No hi ha cap dada de contacte.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="card bg-light mb-3">
            <div class="card-header">
              <form @submit.prevent="enviarComentario">
                <fieldset :disabled="loading.enviarComentario">
                  <div class="input-group">
                    <textarea class="form-control" aria-label="Comentari" style="min-height: 38px;" placeholder="Escriu el teu comentari…" v-model="comentario" required></textarea>
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="submit" title="Enviar comentari" v-tooltip><i class="far fa-paper-plane"></i></button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
            <ul v-if="comentarios.length" class="list-group list-group-flush overflow-auto" style="max-height: 475px;" ref="comentarios">
              <li v-for="comentario in comentarios" class="list-group-item">
                <div class="d-flex w-100 justify-content-between">
                  <h6 class="mb-1">{{ comentario.nom }} {{ comentario.cognoms }}</h6>
                  <small>{{ comentario.alta_comentari }}</small>
                </div>
                <div style="white-space: break-spaces;">{{ comentario.text }}</div>
              </li>
            </ul>
            <div v-else class="card-body lead">
              No hi ha cap comentari.
            </div>
          </div>
        </div>
      </div>
      <div class="row text-center">
        <div class="col">
          <h2 class="mb-3">
            <template v-if="totalHoras">Temps dedicat<span class="badge badge-secondary badge-pill ml-2">{{ totalHoras.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}h</span></template>
            <template v-else>Cap hora de dedicació</template>
          </h2>
        </div>
      </div>
      <div v-for="(hora, index) in horasAgrupadas" :key="index" class="row">
        <div class="col-12 col-sm-6 mx-auto mb-3">
          <div class="card bg-light text-center h-100">
            <div class="card-header">
              <p class="lead mb-0 font-weight-bold" :class="{ 'font-italic': !index }">{{ index ? index : "Sense perfil" }}</p>
            </div>
            <div class="card-body h-100">
              <dl class="list-group list-group-flush text-left">
                <template v-for="trabajador in hora" class="list-group-item">
                  <dt>{{ trabajador.nombre_completo }}</dt>
                  <dd>{{ trabajador.total }}h</dd>
                </template>
              </dl>
            </div>
            <div class="card-footer text-nowrap">
              <h3 class="display-5 font-weight-normal">{{ hora.reduce((a, b) => a + b.total, 0).toLocaleString(undefined, { maximumFractionDigits: 2 }) }}h</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row text-center mt-5">
        <div class="col">
          <h2 class="mb-3">
            <span>Pressupost</span>
            <span v-if="directorioPresupuesto" class="badge badge-secondary badge-pill ml-2" role="button">
              <presupuesto :codigo="codigoPresupuesto" :directorio="directorioPresupuesto" />
            </span>
            <div v-else-if="codigoPresupuesto" class="badge badge-secondary badge-pill ml-2">{{ codigoPresupuesto }}</div>
          </h2>
        </div>
      </div>
      <template v-if="Object.keys(prevision).length">
        <div class="row">
          <div class="col">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="w-25 text-center">Previsió</th>
                  <th scope="col" class="w-25 text-center">Realitat</th>
                </tr>
              </thead>
              <tbody>
                <tr class="desplegable-inferior" data-toggle="collapse" data-target="[data-collapse='personal']" role="button">
                  <th scope="row" class="text-right"><i class="fa-solid fa-caret-right"></i> Personal</th>
                  <th scope="row" class="prevision">{{ Math.round(prevision.totales_personales.prevision) }}€</th>
                  <th scope="row">{{ Math.round(prevision.totales_personales.realidad) }}€</th>
                </tr>
                <tr>
                  <td colspan="3" class="w-100 p-0">
                    <div class="collapse" data-collapse="personal">
                      <table class="w-100">
                        <tr v-for="(fila, index) in prevision.perfiles" :key="index">
                          <td class="text-right">{{ index }}</td>
                          <td class="w-25 prevision">
                            {{ Math.round(fila.coste_prevision) }}€<span v-if="fila.prevision"> ({{ parseFloat(fila.prevision).toLocaleString(undefined, { maximumFractionDigits: 2 }) }}h)</span>
                          </td>
                          <td class="w-25">
                            {{ Math.round(fila.coste_realidad) }}€<span v-if="fila.realidad"> ({{ parseFloat(fila.realidad).toLocaleString(undefined, { maximumFractionDigits: 2 }) }}h)</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
                <tr class="desplegable-inferior" data-toggle="collapse" data-target="[data-collapse='indirectes']" role="button">
                  <th scope="row" class="text-right"><i class="fa-solid fa-caret-right"></i> + Indirectes</th>
                  <th scope="row" class="prevision">{{ Math.round(prevision.totales_indirectos.prevision) }}€</th>
                  <th scope="row">{{ Math.round(prevision.totales_indirectos.realidad) }}€</th>
                </tr>
                <tr>
                  <td colspan="3" class="w-100 p-0">
                    <div class="collapse" data-collapse="indirectes">
                      <table class="w-100">
                        <tr v-for="(fila, index) in prevision.margenes" :key="index">
                          <td class="text-right">{{ margenes[index] }} ({{ fila.porcentaje }}%)</td>
                          <td class="prevision w-25">{{ Math.round(fila.prevision) }}€</td>
                          <td class="w-25">{{ Math.round(fila.realidad) }}€</td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right">Altres despeses</td>
                  <td class="prevision">{{ Math.round(prevision.gastos.prevision) }}€</td>
                  <td>{{ Math.round(prevision.gastos.realidad) }}€</td>
                </tr>
                <tr>
                  <th scope="row" class="text-right">Total cost</th>
                  <th scope="row" class="prevision">{{ Math.round(prevision.totales_costes.prevision) }}€</th>
                  <th scope="row">{{ Math.round(prevision.totales_costes.realidad) }}€</th>
                </tr>
                <tr>
                  <td class="text-right">Marge</td>
                  <td class="prevision">{{ totalMargenMonetario }}€ ({{ Math.round(prevision.margen_prevision) }}%)</td>
                  <th scope="row" :class="margeReal >= 0 ? 'text-success' : 'text-danger'">{{ margeReal }}€ ({{ margeRealPC }}%)</th>
                </tr>
                <tr>
                  <th scope="row" class="text-right">Total pressupost</th>
                  <th scope="row" class="prevision">{{ Math.round(totalPresupuesto) }}€</th>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <div class="row text-center mt-5">
        <div class="col">
          <h2 class="mb-3">
            <template v-if="totalGastos">Despeses<span class="badge badge-secondary badge-pill ml-2">{{ totalGastos.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}€</span></template>
            <template v-else>Cap despesa</template>
          </h2>
        </div>
      </div>
      <div v-if="gastos.length" class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">Data</th>
              <th scope="col">Proveïdor</th>
              <th scope="col">Concepte</th>
              <th scope="col">Import</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fila, index) in gastos" :key="index">
              <td>{{ mostrarFecha(fila.data_despesa) }}</td>
              <td>{{ fila.proveidor }}</td>
              <th scope="row">{{ fila.concepte }}</th>
              <td>{{ fila.import.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}€</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <vacio>Utilitza el formulari superior per a fer una selecció.</vacio>
    </template>
  </div>
</template>

<script>
import EstadisticaProyecto from "../components/EstadisticaProyecto.vue";
import Presupuesto from "../components/Presupuesto.vue";

export default {
  name: "ResumPeriodeHores",
  inject: ["rangoInicioLTM", "rangoFinLTM", "rangoInicioYTD", "rangoFinYTD"],
  components: {
    EstadisticaProyecto,
    Presupuesto,
  },
  data() {
    return {
      loading: {
        filtrado: false,
        enviarComentario: false,
        comentarios: false,
      },
      tipoRango: "tot",
      tipoRangos: ["tot", "LTM", "YTD"],
      gastos: [],
      horas: [],
      horasAgrupadas: {},
      totalGastos: 0,
      totalHoras: 0,
      proyecto_escogido: "",
      proyectos: [],
      rango_inicio: "",
      rango_fin: "",
      esFiltrado: false,
      prevision: {},
      margenes: {
        comercial: "Costos departament comercial",
        coordinacion: "Costos gerència + administració + coordinació",
        indirectos: "Costos indirectes interns Ecostudi",
      },
      comentario: "",
      comentarios: [],
    };
  },
  computed: {
    contacto() {
      if (!this.proyecto) return;

      return this.proyecto.contacte_nom || this.proyecto.contacte_carrec || this.proyecto.contacte_email || this.proyecto.contacte_telefon ? true : false;
    },
    proyecto() {
      if (!this.proyecto_escogido) return;

      return this.proyectos.find(proyecto => proyecto.id == this.proyecto_escogido);
    },
    rangoInicioTodo() {
      return "";
    },
    rangoFinTodo() {
      return "";
    },
    rango_max: function () {
      let date = new Date();

      date.setDate(date.getDate());

      return this.toDateISOString(date);
    },
    codigoPresupuesto() {
      if (!this.proyecto_escogido) return;

      return this.proyectos.find((a) => a.id == this.proyecto_escogido)?.codi_pressupost;
    },
    directorioPresupuesto() {
      if (!this.proyecto_escogido) return;

      return this.proyectos.find((a) => a.id == this.proyecto_escogido)?.directori;
    },
    margeReal() {
      if (!this.prevision) return 0;
      if (!this.totalPresupuesto) return 0;

      const x = (this.totalPresupuesto) - (this.prevision.totales_costes.realidad ?? 0);

      return isNaN(x) ? 0 : Math.round(x);
    },
    margeRealPC() {
      if (!this.margeReal) return 0;
      if (!this.totalPresupuesto) return 0;

      const x = ((this.margeReal ?? 0) / (this.totalPresupuesto ?? 1)) * 100;

      return Math.round(isNaN(x) ? 0 : x);
    },
    totalMargenMonetario() {
      if (!this.prevision) return;

      return Math.round((this.prevision.totales_costes.prevision / (1 - (this.prevision.margen_prevision / 100))) - this.prevision.totales_costes.prevision);
    },
    totalPresupuesto() {
      if (!this.prevision) return;

      const x = Math.round(this.prevision.totales_costes.prevision) / (1 - (Math.round(this.prevision.margen_prevision) / 100));

      return isNaN(x) ? 0 : x;
    },
  },
  mounted() {
    this.$http.get("api/projectes?order=cliente").then((response) => {
      this.proyectos = response.data;

      const proyectoEntrante = parseInt(this.$router.history.current.query.id);

      if (proyectoEntrante && this.proyectos.some((a) => a.id == proyectoEntrante)) {
        this.proyecto_escogido = proyectoEntrante;

        if (this.$router.history.current.query.filtre) {
          this.tipoRango = this.$router.history.current.query.filtre;
        }

        this.$nextTick(() => {
          this.$refs.submit.click();
        });
      }
    });
  },
  methods: {
    enviarComentario() {
      this.loading.enviarComentario = true;

      this.$http.post(`api/comentaris`, { id_projecte: this.proyecto.id, text: this.comentario })
        .then(response => {
          this.comentario = "";

          this.comentarios.unshift({
            ...response.data, alta_comentari: (new Date(response.data.alta_comentari)).toLocaleString([], {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            })
          });

          this.$refs.comentarios.scroll({
            top: 0,
            behavior: "smooth",
          });
        })
        .finally(() => this.loading.enviarComentario = false);
    },
    comprobarTelefonoValido(telefono) {
      const regex = /^[0-9 ]+$/;

      return regex.test(telefono);
    },
    comprobarEmailValido(email) {
      const input = document.createElement('input');
      input.type = 'email';
      input.value = email;

      return input.checkValidity();
    },
    comprobarRango() {
      switch (true) {
        case this.rango_inicio == this.rangoInicioTodo && this.rango_fin == this.rangoFinTodo:
          this.tipoRango = this.tipoRangos[0];
          break;
        case this.rango_inicio == this.rangoInicioLTM && this.rango_fin == this.rangoFinLTM:
          this.tipoRango = this.tipoRangos[1];
          break;
        case this.rango_inicio == this.rangoInicioYTD && this.rango_fin == this.rangoFinYTD:
          this.tipoRango = this.tipoRangos[2];
          break;
      }
    },
    reiniciarFilas: function () {
      this.rango_inicio = "";
      this.rango_fin = "";
      this.gastos = [];
      this.horas = [];
      this.esFiltrado = false;
    },
    toDateISOString: function (date) {
      return date.toISOString().split("T")[0];
    },
    listarFilas: function () {
      this.esFiltrado = true;

      this.$http.get(`api/dedicacions?${new URLSearchParams({ perfil: true, fecha_inicio: this.rango_inicio, fecha_fin: this.rango_fin, proyecto_escogido: this.proyecto_escogido })}`).then((response) => {
        this.horas = response.data;
      });

      this.$http.get(`api/despeses?${new URLSearchParams({ fecha_inicio: this.rango_inicio, fecha_fin: this.rango_fin, proyecto: this.proyecto_escogido })}`).then((response) => {
        this.gastos = response.data;
      });

      this.$http.get(`api/projectes/${this.proyecto_escogido}?${new URLSearchParams({ prevision: true, fecha_inicio: this.rango_inicio, fecha_fin: this.rango_fin })}`).then((response) => {
        this.prevision = response.data;
      });
    },
    mostrarFecha: function (fecha) {
      return new Date(fecha).toLocaleDateString("ca-ES");
    },
  },
  watch: {
    horas: function (value) {
      this.totalHoras = 0;

      value.forEach((element) => {
        element.total = parseFloat(element.total);
        this.totalHoras += element.total;
      });

      this.horasAgrupadas = value.reduce((group, horas) => {
        const { perfil } = horas;
        group[perfil ?? ""] = group[perfil ?? ""] ?? [];
        group[perfil ?? ""].push(horas);
        return group;
      }, {});
    },
    gastos: function (value) {
      this.totalGastos = 0;

      value.forEach((element) => {
        element.import = parseFloat(element.import);
        this.totalGastos += element.import;
      });
    },
    rango_fin() {
      this.comprobarRango();
    },
    rango_inicio() {
      this.comprobarRango();
    },
    tipoRango(value) {
      switch (value) {
        case "tot":
          this.rango_inicio = this.rangoInicioTodo;
          this.rango_fin = this.rangoFinTodo;
          break;
        case "LTM":
          this.rango_inicio = this.rangoInicioLTM;
          this.rango_fin = this.rangoFinLTM;
          break;
        case "YTD":
          this.rango_inicio = this.rangoInicioYTD;
          this.rango_fin = this.rangoFinYTD;
          break;
      }
    },
    proyecto(value) {
      this.loading.comentarios = true;

      this.$http.get(`api/comentaris?id_projecte=${value.id}`)
        .then(response => this.comentarios = response.data.map(comentario => ({
          ...comentario, alta_comentari: (new Date(comentario.alta_comentari)).toLocaleString([], {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          })
        })))
        .finally(() => this.loading.comentarios = false)
    },
  },
};
</script>

<style lang="scss" scoped>
.prevision {
  background-color: rgba(0, 0, 0, 0.025);
}
</style>